module.exports = __webpack_public_path__ + "static/img/dwg.c51c23d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dwg.jpg
// module id = E8UK
// module chunks = 1